<template>
  <div class="login">
    <v-container class="fill-height" fluid>
      <!-- <v-row align="center" justify="center">
        <v-btn color="primary" @click="setLayout('auth-layout')">Simple Layout</v-btn>
        <v-btn color="warning" @click="setLayout('admin-layout')">App Layout</v-btn>
      </v-row>-->
      <v-row align="center" justify="center">
        <v-col cols="12" sm="6" md="4">
          <v-card :loading="loading" class="elevation-1 mt-12 pa-3">
            <v-row align="center" justify="center">
              <v-img src="/img/appsensi_logo.png" aspect-ratio="1" max-width="300" contain></v-img>
            </v-row>
            <v-card-text>
              <v-form>
                <v-text-field
                  label="Login"
                  name="login"
                  prepend-icon="mdi-account"
                  type="text"
                  v-model="model.email"
                />
                <v-text-field
                  id="password"
                  label="Password"
                  name="password"
                  :value="model.password"
                  prepend-icon="mdi-lock"
                  :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="() => (value = !value)"
                  :type="value ? 'password' : 'text'"
                  v-model="model.password"
                  @keyup.enter="loginWithFirebase"
                />
              </v-form>
              <p class="text-center warning--text" v-if="feedback">{{ firebaseFeedback }}</p>
            </v-card-text>
            <v-card-actions class="px-3 pb-6">
              <v-btn block rounded color="primary" @click="loginWithFirebase" :loading="loading">
                Login
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      model: {
        // email: "admin3000@appsensi.com",
        // password: "admin3000"
        email: "",
        password: ""
      },
      feedback: null,
      loading: false,
      value: true,
    };
  },
  computed: {
    firebaseFeedback() {
      switch(this.$store.state.error_login) {
        case 'auth/invalid-email':
          return 'The email address is badly formatted!'
        case 'auth/user-not-found':
          return 'User not found!'
        case 'auth/user-disabled':
          return `This Account has been disabled by your company's administrator. Please contact your company administrator for more information.`
        case 'auth/wrong-password': 
          return 'Invalid Password!'
        case 'auth/too-many-requests':
          return 'Too many attempts, Please try again later.'
        default:
          return(this.$store.state.error)
      }
    },
    userLoggedIn() {
      return this.$store.getters.user.id;
    }
  },
  methods: {
    goToDashboard() {
      this.$router.push({ name: "summary-report" });
    },
    async loginWithFirebase() {
      this.loading = true;
      const user = {
        email: this.model.email,
        password: this.model.password
      };
      try {
        await this.$store.dispatch("signIn", user);
      } catch (ex) {
        this.feedback = "Failed to load data";
      } finally {
        this.loading = false;
      }
      this.feedback = this.$store.getters.error;
    }
  },
  created() {
    const query = this.$route.query
    if(query.opt){
        this.$cookie.delete('optv3');
      }
    if (this.userLoggedIn) {
      const vuex = localStorage.getItem('vuex')
      if (vuex != null) this.goToDashboard()
    }
  },
};
</script>
